import {
  Box,
  TextField,
  Typography,
  Button,
  Alert,
  Paper,
  Grid
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../api/useApi";
import BackButton from "../components/BackButton";

function ScoreLevelsForm() {
    console.log('rendering score levels form');
  const navigate = useNavigate();
  const { request } = useApi();

  const [formData, setFormData] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    loadScoreLevels();
  }, []);

  const loadScoreLevels = async () => {
    try {
      const response = await request({
        url: "/admin/score-levels",
        method: "GET",
      });

      console.log("Score levels data:", response);

      setFormData(response || []);
    } catch (err) {
      console.error(err);
      setError("Unable to load score levels");
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...formData];

    updated[index] = {
      ...updated[index],
      [field]:
        field === "displayOrder" ||
        field === "minScore" ||
        field === "maxScore"
          ? Number(value)
          : value,
    };

    setFormData(updated);
  };

  const validateScoreRanges = () => {
    const sorted = [...formData].sort(
        (a, b) => a.displayOrder - b.displayOrder
    );

    // First range should start with 0
    if (sorted[0].minScore !== 0) {
        return "First level must start from 0";
    }

    // Last range should end with 100
    if (
        sorted[sorted.length - 1].maxScore !== 100
    ) {
        return "Last level must end at 100";
    }

    for (let i = 0; i < sorted.length; i++) {
        const current = sorted[i];

        // max should be greater than min
        if (
        current.maxScore <= current.minScore
        ) {
        return `${current.levelName}: max score must be greater than min score`;
        }

        // Compare with next item
        if (i < sorted.length - 1) {
        const next = sorted[i + 1];

        if (
            next.minScore !==
            current.maxScore + 1
        ) {
            return `Invalid range between ${current.levelName} and ${next.levelName}. Expected ${next.levelName} minimum to be ${current.maxScore + 1}`;
        }
        }
    }

    return null;
    };

  const handleSubmit = async () => {
    const validationError =
        validateScoreRanges();

    if (validationError) {
        setError(validationError);
        return;
    }
    try {
      setError("");
      setSuccess("");

      await Promise.all(
        formData.map((item) =>
          request({
            url: `/admin/score-levels/${item.levelName.toLowerCase()}`,
            method: "PUT",
            data: {
              minScore: item.minScore,
              maxScore: item.maxScore,
              displayOrder: item.displayOrder,
            },
          })
        )
      );

      setSuccess(
        "Score levels updated successfully"
      );

      await loadScoreLevels();
    } catch (err) {
      console.error(err);

      setError(
        err?.message ||
          "Failed to update score levels"
      );
    }
  };

  const handleCancel = () => {
    navigate("/");
  };

  return (
          <Grid container component="main" sx={{ minHeight: "90vh", position: "relative", display: "flex", justifyContent: "center", alignItems: "center", p: 2 }}>
            <Paper sx={{ display: "flex", p: 4, borderRadius: 4, maxWidth: "100%", width: "77vw", overflowY: "auto", boxShadow: 6, background: "rgba(255,255,255,0.15)", backdropFilter: "blur(5px) saturate(180%)", flexDirection: "column" }}>
            <Box
              sx={{
                p: 4,
                maxWidth: "900px",
                margin: "auto",
              }}
            >
              <BackButton />
              <Typography
                variant="h5"
                sx={{
                  mb: 4,
                  fontWeight: 600,
                }}
              >
                Score Levels
              </Typography>

              {formData.map((item, index) => (
                <Paper
                  key={item.id}
                  sx={{
                    p: 3,
                    mb: 3,
                    borderRadius: "20px",
                  }}
                >
                  <Typography
                    sx={{
                      mb: 2,
                      fontWeight: 600,
                    }}
                  >
                    {item.levelName}
                  </Typography>

                  <Box
                    display="flex"
                    gap={2}
                  >
                    <TextField
                      label="Min Score"
                      type="number"
                      value={item.minScore}
                      onChange={(e) =>
                        handleChange(
                          index,
                          "minScore",
                          e.target.value
                        )
                      }
                    />

                    <TextField
                      label="Max Score"
                      type="number"
                      value={item.maxScore}
                      onChange={(e) =>
                        handleChange(
                          index,
                          "maxScore",
                          e.target.value
                        )
                      }
                    />

                    <TextField
                      label="Display Order"
                      type="number"
                      value={item.displayOrder}
                      onChange={(e) =>
                        handleChange(
                          index,
                          "displayOrder",
                          e.target.value
                        )
                      }
                    />
                  </Box>
                </Paper>
              ))}

              {error && (
                <Alert
                  severity="error"
                  sx={{ mb: 2 }}
                >
                  {error}
                </Alert>
              )}

              {success && (
                <Alert
                  severity="success"
                  sx={{ mb: 2 }}
                >
                  {success}
                </Alert>
              )}

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  mt: 4,
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>

                <Button
                  variant="outlined"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
            </Paper>
          </Grid>
  );
}

export default ScoreLevelsForm;